module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Allschwil-f19b78bebd42f1aa9add747703b3ba85.png";